import { Storage } from "aws-amplify"

export const GetFileLink = (key) => {
    const data = Storage.get(key, {
        customPrefix: {
            public:''
        }
    });
    return data;
}